import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import "../Styles/HistoryUploadCss.css";
import {
  batchDeleteHistoryFiles,
  deleteHistoryFile,
  getUploadHistoryDetailsAPI,
  submitHistoryUploadDetails,
} from "../../../../service/StudyListService";
import { useTranslation } from "react-i18next";
import userContext from "../../../../context/users/UserContext";
import { MODAL_TYPE, TOAST_TYPE, USERTYPES } from "../../../../constants/Constants";
import ConfirmModal from "../../../../components/Modal/ConfirmModal";
import ModalMain from "../../../../components/Modal/ModalMain";
import UploadHistoryBody from "./UploadHistoryBody";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import studylistContext from "../../../../context/studylist/StudylistContext";
import loaderContext from "../../../../context/loader/LoaderContext";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../helpers/Amplitude";
import { removeExif } from "../../../../helpers/ExifDataRemover";
import toastContext from "../../../../context/toast/ToastContext";
import {isMobile} from "react-device-detect";

const UploadHistory = (props) => {
  const { roles,username, isActiveData } = useContext(userContext);
  const {dataQueryState,setDataQueryState} = useContext(studylistContext);
  const { showToastv2 } = useContext(toastContext);
  const {ref, setLoaderRunning, setShowModal, showModal} = useContext(loaderContext);
  const [files1, setFiles1] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [fileList, setFileList] = useState({});
  const [loadingState, setLoadingState] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [historyDetails, setHistoryDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [enableBatchDelete, setEnableBatchDelete] = useState(false);
  const [technicianContactList, setTechnicianContactList] = useState([]);
  const [selectedTechnicianContact, setSelectedTechnicianContact] = useState(null);
  const [technicianContactDetails, setTechncianContactDetails] = useState([]);
  const [batchDeleteClicked, setBatchDeleteClicked] = useState(false);
  
  const fileTypes = [
    "JPEG",
    "jpeg",
    "PNG",
    "png",
    "application/octet-stream",
    "text/plain",
    "DCM",
    "dcm",
    "PDF",
    "pdf",
    "JPG",
    "jpg",
    "TXT",
    "txt",
    "DOC",
    "doc",
    "DOCX",
    "docx",
    "GIF",
    "gif",
  ];

  const allowedFileTypes = [
    "JPEG",
    "jpeg",
    "PNG",
    "png",
    "text/plain",
    "PDF",
    "pdf",
    "JPG",
    "jpg",
    "TXT",
    "txt",
    "DOC",
    "doc",
    "DOCX",
    "docx",
  ];
  const [alertMessage, setAlertMessage] = useState("");
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [deletedId, setDeletedId] = useState("");
  const [loadingTopLoader, setLoadingTopLoader] = useState(false);
  const [historyAvailableDto, setHistoryAvailableDto] = useState(null);
  const [selectedSubModalityIds, setSelectedSubModalityIds] = useState([]);
  const [subModalityList, setSubModalityList] = useState(null);
  const [studyDecription, setStudyDescription] = useState(null);
  const [choosenSubModality, setChoosenSubModality] = useState(null);
  const [customDescription, setCustomDescription] = useState("");

  const loadRef = useRef(null);

  const { setAlertSuccessModal, alertSuccessModal } =
    useContext(studyReportContext);

  const [t] = useTranslation();

  //   const studyId = 137;
  const studyId = props.studyId;

  function hideHistoryUploadModal() {
    props.setShowUploadHistoryModal(false);
    setFileNames([]);
    setFiles1([]);
  }

  const handleFileUploadChange = async (fileList) => {
    let list = [];
    let finalList = [];

    for (let [key, value] of Object.entries(fileList)) {
      const newValue = await removeExif(value);

      const fileNameWithoutExtension = newValue.name.split('.').slice(0, -1).join('.');
      if (fileNameWithoutExtension.length > 30) {
        if(isMobile){
          setShowModal(() => {
            const newItem = { ...showModal };
            newItem.show = true;
            newItem.type = MODAL_TYPE.ALERT_MODAL;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("upload-history.big-file-name-error")+": "+fileNameWithoutExtension;
            return newItem;
          });
        }else{
          showToastv2(TOAST_TYPE.ERROR, t("upload-history.big-file-name-error")+": "+fileNameWithoutExtension);
        }
       
        
        continue;
      }

      list.push(newValue.name);
      finalList.push(newValue); 

    }
    let combinedFinalList = files1.concat(finalList);
    let combinedList = fileNames.concat(list);
    setFiles1(combinedFinalList);
    setFileNames(combinedList);
  };

  const removeUploadedFile = (index) => {
    let tempFiles = files1.filter((ele, ind) => {
      return ind != index;
    });
    let tempFiles1 = fileNames.filter((ele, ind) => {
      return ind != index;
    });
    setFiles1(tempFiles);
    setFileNames(tempFiles1);

    const clinicalNoteInput = document.querySelector('textarea[name="clinicalNote"]');
    const clinicalNoteValue = clinicalNoteInput ? clinicalNoteInput.value.trim() : "";

    // console.log("After removing new file:");
    // console.log("Remaining files:", tempFiles.length);
    // console.log("Clinical Note:", clinicalNoteValue);

    if (tempFiles.length === 0 && clinicalNoteValue === "") {
      //console.log("Both file and text removed -> historyStatus false");
      handleRowUpdateForHistoryUpload(false); 
    } else {
      //console.log("Either file or text present -> historyStatus true");
      handleRowUpdateForHistoryUpload(true);
    }
  
  };

  const postProcessAndGetTechnicalContactIds = (value)=>{
    if(value == null || value == undefined) return null;
    return value.split(":")[0];
  }

  const getIsSaved = (technicianContactId) => {
    if(technicianContactId == null || technicianContactId == undefined || technicianContactId.trim().length == 0) 
      return 0;
    let targetId = technicianContactId;
    for (let i = 0; i < technicianContactDetails.length; i++) {
      let technician = technicianContactDetails[i];
      let tempTechnician = technician.id + ":" + technician.mobile
      if((technician.saved != undefined && technician.saved != null) && tempTechnician == targetId ) {
        return technician.saved
      }
    }
    return 0;
  }

  const historyUploadApiPayload = (values) => {
    return {
      studyId: studyId,
      clinicalNote: values.clinicalNote,
      technicianContactId: postProcessAndGetTechnicalContactIds(values.technicianContactId),
      isSaved: getIsSaved(values.technicianContactId),
      subModalityIds: selectedSubModalityIds,
      choosenSubModality: choosenSubModality,
      description: studyDecription
    };
  };



  const getUploadHistoryDetails = async () => {
    try{
      setLoaderRunning(true);
      ref.current.continuousStart();
      const details = await getUploadHistoryDetailsAPI(studyId, props.activeData, props.clientId, props.firmId, props.modalityId);
      console.log("--- Response ----",details);
      if (details.data.result === "SUCCESS") {
        setValues({
          ...values,
          clinicalNote: details.data.data.clinicalNote, // Replace with the new value
          files: details.data.data.historyDoc, // Replace with the new value
          technicianContactId: getSelectedContact(details.data.data.technicianContactList), // Replace with the new value
        });

        setHistoryDetails(details.data.data.clinicalNote);
        setUploadedFiles(details.data.data.historyDoc);
        updateTechnicianContactList(details.data.data.technicianContactList);
        updateSelectedContact(details.data.data.technicianContactList);
        setHistoryAvailableDto(details.data.data.historyAvailableDto);
        setSubModalityList(details.data.data.subModalityList ? JSON.parse(details.data.data.subModalityList) : []);
        setSelectedSubModalityIds(details.data.data.selectedSubModalityIds);
        setCustomDescription(details.data.data?.customDescription);

        setLoaderRunning(false);
        ref.current.complete();
        }else{
          setLoaderRunning(false);
          ref.current.complete();
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("string-literals.error-msg");
            return newItem;
          });
        }
    }catch(e){
      setLoaderRunning(false);
      ref.current.complete();
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
   
  };

  const handleBatchDelete = async () => {
    let checkBox = document.querySelectorAll(".delete-checkbox:checked");

    console.log(checkBox)
    if (checkBox.length > 0) {
      let selectedIds = [];
      checkBox.forEach((element) => {
        let parent = element?.parentElement?.parentElement;
        parent.style.display = "none";
        selectedIds.push(element.id);
      });
      console.log("--- Batch Delete running ----",selectedIds)
      setLoadingTopLoader(true);
      loadRef.current.continuousStart();
      const deleteResponse = await batchDeleteHistoryFiles(
        studyId,
        selectedIds
      );
      console.log(deleteResponse);
      setFileNames([]);
      setFiles1([]);
      if (deleteResponse.data.result === "SUCCESS") {
        // props.setShowUploadHistoryResponseMessage("History record has been deleted successfully.");
        setLoadingTopLoader(false);
        loadRef.current.complete();
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("upload-history.upload-delete-success");
          return newItem;
        });
      } else {
        // props.setShowUploadHistoryResponseMessage("Some error found!!");
        setLoadingTopLoader(false);
        loadRef.current.complete();
        // props.setShowUploadHistoryResponseMessage("Some error found!!");
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("string-literals.error-msg");
          return newItem;
        });
      }
      props.setShowUploadHistoryModal(false);
      //props.setShowConfirmModal(true);
      //props.setShowUploadHistoryResponseModal(true);
    }else{
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("upload-history.upload-delete-no-select");
          return newItem;
        });
        handleDeleteCancelModal();
    }
  };

  const handleDelete = async () => {
    console.log(deletedId);
    let delHistory = document.getElementById(deletedId);
    console.log(delHistory);
    let parent = delHistory.parentElement.parentElement;
    parent.style.display = "none";
    setLoadingTopLoader(true);
    loadRef.current.continuousStart();
    const deleteResponse = await deleteHistoryFile(studyId, deletedId);
    setConfirmDeleteModal(false);
    setShowConfirmModal(false);
    setFileNames([]);
    setFiles1([]);
    if (
      deleteResponse.status === 200 &&
      deleteResponse.data.result === "SUCCESS"
    ) {
      // props.setShowUploadHistoryResponseMessage("History record has been deleted successfully.");
      const clinicalNoteInput = document.querySelector('textarea[name="clinicalNote"]');
      const clinicalNoteValue = clinicalNoteInput ? clinicalNoteInput.value.trim() : "";
      //console.log("After deleting uploaded file:");
      //console.log("Remaining uploaded files:", uploadedFiles.length - 1); // -1 because we just deleted one
      //console.log("Clinical Note:", clinicalNoteValue);
      if (uploadedFiles.length - 1 === 0 && clinicalNoteValue === "") {
        //console.log("All files and text removed -> historyStatus false");
        handleRowUpdateForHistoryUpload(false);
      } else {
        //console.log("Either file or text present -> historyStatus true");
        handleRowUpdateForHistoryUpload(true);
      }
      setLoadingTopLoader(false);
      loadRef.current.complete();
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("upload-history.upload-delete-success");
        return newItem;
      });
    } else {
      setLoadingTopLoader(false);
      loadRef.current.complete();
      // props.setShowUploadHistoryResponseMessage("Some error found!!");
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
    //props.setShowConfirmModal(true);
    //props.setShowUploadHistoryResponseModal(true);
    props.setShowUploadHistoryModal(false);
  };

  const handleTechnicianContactOptionChange= (item)=>{
     setSelectedTechnicianContact(item?.value);
     setValues({
      ...values,
      technicianContactId: item?.value, // Replace with the new value
    });

  }
  const updateTechnicianContactList =(contactList) =>{
    setTechnicianContactList(
      contactList.map(contact =>{
        return {value : contact.id + ":" + contact.mobile, label : contact.name + " " + contact.mobile};
      })
    );

    setTechncianContactDetails(contactList)
  }
  const updateSelectedContact =(contactList) =>{
    console.log('all contactlist', contactList);
    contactList.forEach(contact =>{
      if(contact.saved !== null && contact.saved === 1){
        setSelectedTechnicianContact(contact.id + ":" + contact.mobile);
      }
    })
  }

  const getSelectedContact = (contactList) => {
    for (let contact of contactList) {
      if (contact.saved !== null && contact.saved === 1) {
        return `${contact.id}:${contact.mobile}`; 
      }
    }
    return null; 
  };

  const handleDeleteConfirmModal = (id) => {
    console.log("--- Handle Delete history ----",id);
    setDeletedId(id);
    setAlertMessage(
      t("upload-history.delete-confirmation-history")
    );
    setConfirmDeleteModal(true);
    setShowConfirmModal(true);
  };

  const handleBatchDeleteConfirmModal = (id) => {
    console.log("--- Handle Delete history ----",id);
    setAlertMessage(
      t("upload-history.delete-confirmation-history")
    );
    setBatchDeleteClicked(true);
    setConfirmDeleteModal(true);
    setShowConfirmModal(true);
  };

  const handleDeleteCancelModal = () => {
    setConfirmDeleteModal(false);
    setShowConfirmModal(false);
    setBatchDeleteClicked(false);
  };

  const handleRowUpdateForHistoryUpload = (history) => {
    let newIndex = -1;
    let newData = dataQueryState?.data?.rows.filter((row, index) => {
      if (row.id == studyId) {
        newIndex = index;
        return true;
      }
      return false;
    });
    if(history){
      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState,
        };
        if(newValue.data.rows[newIndex]?.historyStatus != undefined){
          newValue.data.rows[newIndex].historyStatus = true;
        }
        if(newValue.data.rows[newIndex]?.allowAssignment != undefined){
          newValue.data.rows[newIndex].allowAssignment = true;
        }
        return newValue;
      });
    }else{
      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState,
        };
        if(newValue.data.rows[newIndex]?.historyStatus != undefined){
          newValue.data.rows[newIndex].historyStatus = false;
        }
        return newValue;
      });
    }
      
  }

  const getMessageContainingVirusFile = (virusDto, unprocessedDto) => {
    let message = "";
    if (virusDto.otherFileUploaded) {
      message += "History uploaded successfully, but one or more files were detected as infected and not uploaded.";
      if (virusDto?.fileNames?.length > 0) {
        message += " Infected files:";
        virusDto?.fileNames?.forEach((fileName) => {
            message += ` ${fileName},`;
        });
        message = message.slice(0, -1); 
      }
      if(unprocessedDto?.fileNames?.length > 0) {
        message += "Unprocessed files:";
        unprocessedDto?.fileNames?.forEach((fileName) => {
            message += ` ${fileName},`;
        });
        message = message.slice(0, -1); 
      }
    } else if(unprocessedDto?.fileNames?.length > 0) {
        message = "History upload unsuccessful. Some error occured while uploading the file.";
    } else {
        message = "History upload unsuccessful. Some files were detected as infected.";
    }
    return message;
}


  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    isSubmitting,
    setValues,
  } = useFormik({
    initialValues: {
      clinicalNote: historyDetails,
      files: uploadedFiles,
      studyId: historyDetails?.studyId,
      technicianContactId : selectedTechnicianContact
    },
    // enableReinitialize: true,
    // validationSchema: HistoryUploadSchema,
    onSubmit: async (values) => {
      
      const historyUploadDto = historyUploadApiPayload(values);

      console.log("--- Files ---",files1,historyUploadDto);
      if(historyUploadDto.clinicalNote == null && files1.length == 0 && (selectedSubModalityIds == undefined || selectedSubModalityIds == null || selectedSubModalityIds?.length == 0)){
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("upload-history.no-upload-history-clinical-notes");
          return newItem;
        });
        return;
      }else if (process.env.REACT_APP_VDC_PLATFORM === "false" 
        && historyAvailableDto?.subModalityMandatory == true 
        && selectedSubModalityIds?.length == 0
        && historyAvailableDto?.modalityIds?.includes(String(props.modalityId))){
        setAlertSuccessModal(() => {
          const newItem = { ...alertSuccessModal };
          newItem.show = true;
          newItem.heading = "Alert";
          newItem.isError = false;
          newItem.isSuccess = false;
          newItem.isWarning = true;
          newItem.description = t("upload-history.no-sub-modality-selected");
          return newItem;
        });
        return;
      }
      setLoadingState("history upload submit");
      setLoading(true);
      setLoadingTopLoader(true);
      loadRef.current.continuousStart();

      const response = await submitHistoryUploadDetails(
        historyUploadDto,
        files1
      );
      
      setLoading(false);

      if (response.status === 200 && response.data.result === "SUCCESS") {
        console.log("---- Response of upload history ----",response);
        setFileNames([]);
        setFiles1([]);
        setLoadingTopLoader(false);
        loadRef.current.complete();
        if ((files1.length > 0) || (values.clinicalNote && values.clinicalNote.trim() !== "")) {
          handleRowUpdateForHistoryUpload(true);
        } else {
          handleRowUpdateForHistoryUpload(false);
        }
        handleRowUpdateForHistoryUpload(response.data.data.historyPresent);
        let eventProperties = {
          "STUDY ID": studyId,
        };
        logAmplitudeEventWithUsernameAndRole(
          "EVENT_BASIC_CLINICAL_HISTORY_UPLOAD_CLICKED",
          eventProperties,
          username
        );
        // props.setShowUploadHistoryResponseMessage("History Uploaded Successfully!");
        if((response?.data?.data?.virusFileDataDto != null && response?.data?.data?.virusFileDataDto != undefined && response?.data?.data?.virusFileDataDto?.virusPresent) || (response?.data?.data?.unProcessedFileDataDto.fileNames.length > 0)){
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = getMessageContainingVirusFile(response?.data?.data?.virusFileDataDto, response?.data?.data?.unProcessedFileDataDto);
            return newItem;
          });
        }else{
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("upload-history.upload-success");
            return newItem;
          });
        }
        
      } else {
        // props.setShowUploadHistoryResponseMessage("Some error found!!");
        console.log("--- Error Response ---",response);
        if(response?.status === 429){
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("error.upload-limit-exceeded");
            return newItem;
          });
          setLoadingTopLoader(false);
          loadRef.current.complete();
          return;
        }
        if(response.status === 415){
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = response.data.message;
            return newItem;
          });
        }else{
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("string-literals.error-msg");
            return newItem;
          });
        }
       
        setLoadingTopLoader(false);
        loadRef.current.complete();
      }
      //props.setShowConfirmModal(true);
      //props.setShowUploadHistoryResponseModal(true);
      props.setShowUploadHistoryModal(false);
    },
  });

  let PrimaryButtonList = [
    {
      title: t("button.upload"),
      onclick: handleSubmit,
      disabled: !isActiveData,
    },
    {
      title: t("button.batch-delete"),
      onclick: handleBatchDeleteConfirmModal,
      disabled: !isActiveData,
    },
  ];

  let PrimaryButtonListWithoutBatchDelete = [
    {
      title: t("button.upload"),
      onclick: handleSubmit,
      disabled: !isActiveData,
    },
  ];
  let DefaultButtonList = [
    {
      title: t("button.cancel"),
      onclick: hideHistoryUploadModal,
    },
  ];

  let modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        patientName="Mary Frank"
        patientID="123456"
        heading={t("history-upload.title")}
        handleCancel={hideHistoryUploadModal}
      />
    ),
    footer:
      ((roles[0] !== USERTYPES.RADIOLOGIST && roles[0] !== USERTYPES.TYPIST) && !props.isChild) ? (
        <ModalFooter 
        PrimaryButtonList={uploadedFiles.length > 0 ? PrimaryButtonList: PrimaryButtonListWithoutBatchDelete}
          DefaultButtonList={DefaultButtonList}
          enableBatchDelete = {enableBatchDelete}
        />
      ) : null,
    body: (
      <UploadHistoryBody
        loadRef={loadRef}
        studyId={studyId}
        setLoadingTopLoader={setLoadingTopLoader}
        loadingTopLoader={loadingTopLoader}
        handleChange={handleChange}
        values={values}
        handleFileUploadChange={handleFileUploadChange}
        removeUploadedFile={removeUploadedFile}
        fileNames={fileNames}
        uploadedFiles={uploadedFiles}
        handleDeleteConfirmModal={handleDeleteConfirmModal}
        isChild={props.isChild}
        technicianContactList={technicianContactList}
        handleTechinicianContactChange={handleTechnicianContactOptionChange}
        selectedTechnicianContact={selectedTechnicianContact}
        historyAvailableDto={historyAvailableDto}
        subModalityList={subModalityList}
        selectedSubModalityIds={selectedSubModalityIds}
        setSelectedSubModalityIds={setSelectedSubModalityIds}
        setChoosenSubModality={setChoosenSubModality}
        setStudyDescription={setStudyDescription}
        customDescription={customDescription}
        setCustomDescription={setCustomDescription}
      />
    ),
    width: roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.TYPIST? "500px":"785px",
  };

  useEffect(() => {
    getUploadHistoryDetails();
  }, [studyId]);

  useEffect(()=>{
    console.log("------values--------");
    console.log(values);
    },[values]);
  return (
    <div>
      {confirmDeleteModal && showConfirmModal && (
        <ConfirmModal
          handleConfirm={batchDeleteClicked ? handleBatchDelete : handleDelete}
          handleNotConfirm={handleDeleteCancelModal}
          setShowConfirmModal={setShowConfirmModal}
          showConfirmModal={showConfirmModal}
          message={alertMessage}
          title={t("confirm-message.confirm")}
          confirmButtonText={t("confirm-message.yes")}
        />
      )}
      <ModalMain
        showModal={props.showUploadHistoryModal}
        modalDetails={modalDetails}
      />
    </div>
  );
};

export default UploadHistory;

export const UploadHistoryModalFooter = (props) => {
  return (
    <>
      <div className="modal-footer-container">
        {/* <hr className="modal-footer-sep-line" /> */}
        <div className="modal-footer-buttons">
          {props.DefaultButtonList &&
            props.DefaultButtonList.map((obj, index) => (
              <DefaultButton
                key={index}
                text={obj.title}
                style={{
                  marginRight: "8px",
                }}
                onClick={obj.onclick}
              />
            ))}
          {props.PrimaryButtonList &&
            props.PrimaryButtonList.map((obj, index) => (
              <PrimaryButton
                key={index}
                text={obj.title}
                style={{
                  marginRight: "8px",
                }}
                onClick={obj.onclick}
              />
            ))}
        </div>
      </div>
    </>
  );
};
